<script setup lang="ts">
import MLayoutStack from "../../medicus/MLayoutStack";
import { openPage } from "../../../composables/dialog/drawer";
import MList, { MListItem } from "../../medicus/MList";
import { useSnackbar } from "../../../composables/snackbar";

defineProps({
  patients: Array,
  callId: String,
});

function openUrl(url: string, callId: string) {
  openPage(url);
  useSnackbar().remove(callId);
}
</script>

<template>
  <m-layout-stack class="w-full" no-gap>
    <m-list v-for="(patient, i) in patients" :key="i" no-gap class="telephony-patient">
      <m-list-item :sr-label="patient.data[0]" :on-click="() => openUrl(patient.url, callId)">
        <p v-for="(detail, j) in patient.data" :key="j">{{ detail }}</p>
      </m-list-item>
    </m-list>
  </m-layout-stack>
</template>

<style scoped lang="scss">
.telephony-patient {
  min-width: 200px;
}
</style>
